import { buildFreeBetArgsFromBets } from 'newelements/_Betslip/managers/FreeBetManager/utils/build-free-bet-args-from-bets';
import { fetchFreeBetAmounts } from 'newelements/_Betslip/managers/FreeBetManager/utils/fetchFreeBetAmounts';
import { fireCheckProfitBoost } from 'newelements/_Betslip/managers/ProfitBoostManager/actions';
import store from 'store';
import { setAdvancedFreeBetsData } from 'store/actions';
import { IBetslipRootStateInitialData } from 'store/reducers/betslip';

// @Todo need to create some mapping for "Type" field and use it on "Do Bet", "Get Free Bets" and "Create Bet" calls
const ADVANCED_FREE_BET_CALL_TYPE = 2;

export const fetchAdvancedMultipleFreeBets = () => {
  const betslipStore: IBetslipRootStateInitialData = store.getState()?.betSlip;

  const allBets = betslipStore.allLsBets;

  const [events, isLive] = buildFreeBetArgsFromBets(allBets);
  const callback: Parameters<
    typeof fetchFreeBetAmounts
  >['0']['callback'] = data => fireCheckProfitBoost(data, null, true);

  fetchFreeBetAmounts({
    events,
    isLive,
    callback,
    type: ADVANCED_FREE_BET_CALL_TYPE
  }).then(amounts => {
    store.dispatch(setAdvancedFreeBetsData(amounts));
  });
};
